// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__C5Pqs","productName":"Table_productName__2DjIn"};